import { compact, map, filter, every, isEmpty, some, get } from 'lodash'

const coverageFilteredData = ({ customerAssets, filters }) => compact(map(customerAssets, (customer) => {
  const assets = filter(customer.assets, vm => {
    const filterResults = {}

    if (filters.locations != 'All') {
      filterResults['locations'] = some(filters.locations, location => location.value === get(vm, 'location_id'))
    }

    if (filters.functions != 'All') {
      filterResults['functions'] = some(filters.functions, functionOption => functionOption.value === get(vm, 'function'))
    }

    if (filters.powerState != 'All') {
      filterResults['powerState'] = filters.powerState === get(vm, 'power_state')
    }

    if (filters.customers != 'All') {
      filterResults['customers'] = some(filters.customers, customersOption => customersOption.value === get(vm, 'customer_id'))
    }

    if (filters.licenseReportTypes != 'All') {
      filterResults['licenseReportTypes'] = some(filters.licenseReportTypes,
        licenseReportTypesOption => licenseReportTypesOption.value === get(customer, 'license_report_type')
      )
    }

    return (every(filterResults, (value, key) => value === true) || isEmpty(filterResults))
  })

  if (assets.length == 0) { return null }
  return { ...customer, assets }
}))

export { coverageFilteredData }
